import { render, staticRenderFns } from "./Datafeed.vue?vue&type=template&id=55feee2c&scoped=true"
import script from "./Datafeed.vue?vue&type=script&lang=js"
export * from "./Datafeed.vue?vue&type=script&lang=js"
import style0 from "./Datafeed.vue?vue&type=style&index=0&id=55feee2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55feee2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55feee2c')) {
      api.createRecord('55feee2c', component.options)
    } else {
      api.reload('55feee2c', component.options)
    }
    module.hot.accept("./Datafeed.vue?vue&type=template&id=55feee2c&scoped=true", function () {
      api.rerender('55feee2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/CrossOrg/Datafeed.vue"
export default component.exports